interface CycleInsideCirleSVGProps {
  color: string;
  style: React.CSSProperties;
}

const CycleInsideCirleSVG = ({ color, style }: CycleInsideCirleSVGProps) => (
  <svg
    style={style}
    xmlns="http://www.w3.org/2000/svg"
    width="45"
    height="45"
    viewBox="0 0 45 45"
    fill="none"
  >
    <g clipPath="url(#clip0_519_19847)">
      <path
        d="M33.0543 22.5L35.4842 25.3566L38.3408 22.9266"
        stroke={color}
        strokeWidth="2.07749"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.927 25.4124L9.03334 23.0381L6.65906 25.9317"
        stroke={color}
        strokeWidth="2.07749"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.12622 19.4949C10.4989 13.5035 15.841 9.05176 22.2404 9.05176C28.6398 9.05176 34.3344 13.8189 35.4844 20.0884"
        stroke={color}
        strokeWidth="2.07749"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M34.353 28.3798C32.1642 32.8687 27.564 35.9478 22.2404 35.9478C16.9169 35.9478 12.1683 32.7574 10.0352 28.1572"
        stroke={color}
        strokeWidth="2.07749"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M43.9613 22.4993C43.9613 34.3522 34.3529 43.9606 22.5001 43.9606C10.6472 43.9606 1.03882 34.3522 1.03882 22.4993C1.03882 10.6465 10.6472 1.03809 22.5001 1.03809C34.3529 1.03809 43.9613 10.6465 43.9613 22.4993Z"
        stroke={color}
        strokeWidth="2.07749"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_519_19847">
        <rect width="45" height="45" fill={color} />
      </clipPath>
    </defs>
  </svg>
);

export default CycleInsideCirleSVG;
